import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { FaInfoCircle, FaPen, FaPlus, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import IVL_HorarioDisponivel from '../../Interfaces/horarioDisponivel/VL_horarioDisponivel.interface';
import api from '../../Services/ApiService';
import { modelProperties } from '../../Utils/modelproperties';
import CreateReadUpdateModal from '../CreateReadUpdateModal';
import { columns } from '../TabelaHorariosDisponiveisVirtuais/columns';
import { FlexBoxSpaceBetween, StyledButton } from './styles';
// import { Container } from './styles';

const TabelaHorariosDisponiveisVirtuais: React.FC = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selected,setSelected] = useState<number>();
  const [updatedData,setUpdatedData] = useState<boolean>(false);
  const [createReadUpdateModalOpened,setCreateReadUpdateModalOpened] = useState<boolean>(false);
  const [typeCreateReadUpdateModal,setTypeCreateReadUpdateModal] = useState<'create' | 'read'|'update'>('read');
  const [horariosDisponiveis,setHorariosDisponiveis] = useState<IVL_HorarioDisponivel[]>([]);

  useEffect(()=>{
    GetHorariosDisponiveis();
    setUpdatedData(false);
  },[updatedData])

  const GetHorariosDisponiveis = async () => {
    const {data} = await api.get<IVL_HorarioDisponivel[]>('/vl_horariosdisponiveis/virtuais');
    setHorariosDisponiveis(data);
  }

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  
  const handleOpenCreateReadUpdateModal = (type: 'create' | 'read' | 'update', id:number) => {
    setTypeCreateReadUpdateModal(type);
    setSelected(id);
    setCreateReadUpdateModalOpened(true);
  }
  const handleCloseReadOrUpdateModal = () => {
    if(typeCreateReadUpdateModal!=='create')
      setSelected(undefined);
    setCreateReadUpdateModalOpened(false);
  }

  const deletarSessao = async (id:number) => {
    try {
      await api.delete(`/horariosdisponiveis/${id}`);
      Swal.fire({
        title:'Sucesso!',
        text:'O horário foi excluído com sucesso!',
        icon: 'success'
      }).then((result)=>{
        if(result.isConfirmed)
          setUpdatedData(true);
      });
    } catch (error:any) {
      return Swal.fire({
        title:'Erro!',
        text:`${error.response.data}`,
        icon: 'error'
      })
    }
  }

  const handleDeleteHorarioDisponivel = async (id:number) => {
    Swal.fire({
      title: 'Deseja realmente excluir este horário?',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir',
      confirmButtonColor: '#ff0000',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return deletarSessao(id);
      },
      allowOutsideClick: () => !Swal.isLoading()
    });
  }

  return (
    <>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="center" colSpan={7}>
                <h2>
                  Horários Disponíveis para Sessões Virtuais
                </h2>
              </TableCell>
            </TableRow>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, maxWidth: column.maxWidth }}
                >
                <h3>
                  {column.label}
                </h3>  
                </TableCell>
              ))}
              <TableCell align='center'>
                <h3 style={{minWidth:70}}>
                  Ações
                </h3> 
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {horariosDisponiveis
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((horarioDisponivel,index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {columns.map((column) => {
                      const value = horarioDisponivel[column.id];
                      return (
                        <TableCell sx={{fontSize:'10pt',width: column.width}} key={column.id} align={column.align}>
                          <div title={value ? (column.format ? column.format(value) : value.toString()) : ("")} style={{whiteSpace: 'nowrap', overflow:'hidden', textOverflow: 'ellipsis'}}>
                            {column.format
                              ? column.format(value)
                              : value}
                          </div>
                        </TableCell>
                      );
                    })}
                    <TableCell sx={{width:'1vw'}} align='right'>
                      <FlexBoxSpaceBetween>
                        <FaInfoCircle style={{cursor:'pointer'}} onClick={() => handleOpenCreateReadUpdateModal('read',horarioDisponivel.id)}/>
                        <FaPen style={{cursor:'pointer'}} onClick={() => handleOpenCreateReadUpdateModal('update',horarioDisponivel.id)}/>
                        <FaTrash style={{cursor:'pointer', color:'red'}} onClick={() => handleDeleteHorarioDisponivel(horarioDisponivel.id)}/>
                      </FlexBoxSpaceBetween>
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell align="center" colSpan={7}>
                  <StyledButton onClick={()=> handleOpenCreateReadUpdateModal('create',0)} title='Adicionar'>
                    <FaPlus/>
                  </StyledButton>
                </TableCell>
              </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={horariosDisponiveis.length}
        rowsPerPage={rowsPerPage}
        page={page}
        showFirstButton
        showLastButton
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    <CreateReadUpdateModal
      id={selected}
      route='horariosdisponiveis'
      opened={createReadUpdateModalOpened}
      type={typeCreateReadUpdateModal}
      handleClose={handleCloseReadOrUpdateModal}
      modelProperties={modelProperties['horariosdisponiveisvirtuais']}
      updatedData={setUpdatedData}
      />
    </>
  );
}

export default TabelaHorariosDisponiveisVirtuais;